<template>
  <b-container class="sessions">
    <h1>Sessions</h1>

    <div>
      <b-table
        class="sessions-table"
        striped
        hover
        head-variant="dark"
        :items="sessions"
        :busy="!loaded"
        @row-clicked="rowClick"
        ><template #table-busy>
          <div class="text-center text-success my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template></b-table
      >
    </div>
  </b-container>
</template>

<script>
import * as firebase from 'firebase/app';
import 'firebase/auth';
import firebasedb from 'firebase';
import moment from 'moment';

export default {
  data() {
    return {
      loaded: true,
      sessions: [],
      unsubscribeFirestore: null,
    };
  },
  destroyed() {
    this.unsubscribeFirestore();
  },
  mounted() {
    const currentUserId = firebase.auth().currentUser.uid;
    const db = firebasedb.firestore();
    const userSessionsRef = db.collection(currentUserId);

    this.unsubscribeFirestore = userSessionsRef.onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change) => {
        this.loaded = false;
        if (change.type === 'added') {
          this.appendSessionFromFirebaseData(change.doc);
        } else if (change.type == 'modified') {
          this.updateSessionFromFirebaseData(change.doc);
        }
        this.sortSessions();
        this.loaded = true;
      });
    });
  },
  methods: {
    appendSessionFromFirebaseData(firebaseDocument) {
      const documentData = firebaseDocument.data();
      this.sessions.push({
        name: firebaseDocument.id,
        last_time_measured: this.convertToDate(documentData['last_measured']),
        measurements: documentData['measurements'],
      });
    },
    updateSessionFromFirebaseData(firebaseDocument) {
      const documentData = firebaseDocument.data();
      let document = this.sessions.filter(
        (document) => document.name == firebaseDocument.id
      )[0];

      document.last_time_measured = this.convertToDate(
        documentData['last_measured']
      );
      document.measurements = documentData.measurements;
    },
    rowClick(record) {
      this.goToMeasurements(record.name);
    },
    convertToDate(date) {
      return moment(date).format('LLLL');
    },
    sortSessions() {
      this.sessions = this.sessions.sort((a, b) =>
        Number(a.name) > Number(b.name) ? 1 : -1
      );
    },
    goToMeasurements(sessionName) {
      this.$router.push({
        name: 'measurements',
        params: { sessionName: sessionName },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sessions {
  margin-top: 20px;
  padding-bottom: 20px;
}
</style>
